/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Toggle_ActiveInputs */

const en_toggle_active = /** @type {(inputs: Toggle_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toggle ${i?.name}`)
};

const he_toggle_active = /** @type {(inputs: Toggle_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`החלפת מצב ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Toggle {name}" |
*
* @param {Toggle_ActiveInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const toggle_active = /** @type {((inputs: Toggle_ActiveInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_ActiveInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toggle_active(inputs)
	return he_toggle_active(inputs)
});